<!-- DetachedNoteButton.vue -->
<script setup>
import { computed } from "vue";
import { useMemberRestrictions } from "@/composables/useMemberRestrictions";

const emit = defineEmits(["add-detached"]);

const props = defineProps({
  // Criador da atividade atual — para a regra "somente conteúdo do titular".
  activityCreatedByUserId: { type: Number, default: null },
});

const { canCreateNoteInActivity } = useMemberRestrictions();

const memberCanCreateNote = computed(() =>
  canCreateNoteInActivity(props.activityCreatedByUserId)
);

function handleClick() {
  emit("add-detached");
}
</script>

<template>
  <!-- O botão continua na tela quando o vínculo não permite anotar aqui: fica
       esmaecido e inerte, com o motivo no tooltip. Some da tela confundia — a
       pessoa não entendia por que a ação tinha desaparecido. -->
  <button
    type="button"
    class="btn btn-detached"
    :class="{ 'btn-detached--blocked': !memberCanCreateNote }"
    :disabled="!memberCanCreateNote"
    :title="
      memberCanCreateNote
        ? 'Criar nota avulsa'
        : 'Você só pode anotar em atividades preparadas pelo titular ou pelo círculo dele.'
    "
    @click.stop="handleClick"
  >
    <i class="fas fa-plus"></i>
    Nota Avulsa
  </button>
</template>

<style scoped>
.btn-detached {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 0.8rem;
  font-size: 0.85rem;
  font-weight: 500;
  border-radius: 10px;
  border: 1px solid var(--border-color);
  background-color: #eee8ff;
  color: #49309a;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out, transform 0.05s ease;
  gap: 0.35rem;
  white-space: nowrap;
}

.btn-detached:hover {
  background-color: #e2d9ff;
}

/* Bloqueado pelo vínculo: visível, esmaecido e sem resposta ao hover. */
.btn-detached--blocked,
.btn-detached--blocked:hover {
  opacity: 0.45;
  cursor: not-allowed;
  background-color: #eee8ff;
  transform: none;
}

.btn-detached:active {
  transform: translateY(1px);
}
</style>